import { TaxiVoiceProvider } from "@taunggyi-plus/taxi-feature";
import { TaxiSubscriptionRequests } from "@taunggyi-plus/finance-feature";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { PlatformApp } from "@taunggyi-plus/app-shell";
import { AuthProvider } from "@taunggyi-plus/auth";
import { getAppConfig, installPageZoomLock } from "@taunggyi-plus/config";
import { CustomerInformationDialog, TaxiMore } from "@taunggyi-plus/customer-feature";
import "@taunggyi-plus/design-system/styles.css";

import { NotificationCenter } from "@taunggyi-plus/notifications";
import { DriverWorkspace } from "@taunggyi-plus/taxi-feature";

const driverNavigationLabel = {
  en: "My vehicle",
  my: "ယာဉ်မောင်းများ",
  shn: "ၽူႈႁေႃႈ",
  zh: "司机",
} as const;

const authConfig = {
  appId: "taxi",
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
};

installPageZoomLock();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider config={authConfig}>
      <TaxiVoiceProvider>
        <PlatformApp
          config={getAppConfig("taxi")}
          informationContent={(locale, id, onClose) => (
            <CustomerInformationDialog locale={locale} id={id} onClose={onClose} />
          )}
          navigationMode="owner"
          compactNavigation
          contentOwnsHeading={["dashboard", "my-services", "orders", "finance"]}
          dashboardContent={<DriverWorkspace mode="dashboard" />}
          myServicesLabel={(locale) => driverNavigationLabel[locale]}
          myServicesPath="/drivers"
          myServicesContent={<DriverWorkspace mode="profile" />}
          ordersContent={<DriverWorkspace />}
          financeLabel="Finances"
          financeContent={<DriverWorkspace mode="income" />}
          moreContent={(locale, onLocaleChange, onOpenPreferences) =>
            window.location.pathname.replace(/\/+$/, "") === "/more/subscription" ? (
              <TaxiSubscriptionRequests />
            ) : (
              <TaxiMore
                locale={locale}
                onLocaleChange={onLocaleChange}
                onOpenPreferences={onOpenPreferences}
              />
            )
          }
          notificationContent={(locale) => (
            <NotificationCenter
              locale={locale}
              appId="taxi"
              embedded
              webPushPublicKey={import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY}
            />
          )}
        />
      </TaxiVoiceProvider>
    </AuthProvider>
  </StrictMode>,
);
